// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2247":"92baae7a","4050":"c723d8a7"}[chunkId] + ".chunk.css";
};